export default "__VITE_ASSET__dm_XB4Y4__"